<template>
  <div class="diy-service" :style="'right:'+itemStyle.right+'%; bottom:'+itemStyle.bottom+'%'">
  <!-- 拨打电话 -->
  <div v-if="params.type == 'phone'">
    <form @click="_onServiceEvent" report-submit="true">
      <button formType="submit" class="btn-normal">
        <div class="service-icon">
          <img :src="params.image">
        </div>
      </button>
    </form>
  </div>
  <!-- 在线聊天 -->
  <div v-if="params.type == 'chat'">
    <button open-type="contact" class="btn-normal">
      <div class="service-icon">
        <img :src="params.image">
      </div>
    </button>
  </div>
</div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle", "params"],
  created(){
  },
  activated() {
  },
  methods:{
    _onServiceEvent(e) {
      // 记录formid
      App.saveFormId(e.detail.formId);
      // 拨打电话
      wx.makePhoneCall({
        phoneNumber: this.data.params.phone_num
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
/* 在线客服 */

.diy-service {
  position: fixed;
  z-index: 999;
}

.diy-service .service-icon {
  padding: 5px;
}

.diy-service .service-icon img {
  display: block;
  width: 45px;
  height: 45px;
}

</style>